import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _ from 'lodash';
import { isEmptyValue } from '@jutro/data';
import { findContentFromMetadata, prepareContentFromMetadata } from '../render/renderMetadataHelper';
export function validateFieldUsingMetadata(metadata) {
  const componentProps = metadata.componentProps;
  const _ref = componentProps || {},
    required = _ref.required,
    validationMessages = _ref.validationMessages,
    value = _ref.value;
  if (!_.isEmpty(validationMessages)) {
    return false;
  }
  if (required === true && isEmptyValue(value)) {
    return false;
  }
  return true;
}
export function validateContentFromMetadata(contentMetadata, overrideProps, resolvers, rootMetadata = {}, skipHidden = true) {
  const preparedContent = prepareContentFromMetadata(contentMetadata, overrideProps, resolvers, rootMetadata);
  const fieldArray = findContentFromMetadata(preparedContent, item => item.type === 'field', skipHidden);
  const invalid = _someInstanceProperty(fieldArray).call(fieldArray, item => !validateFieldUsingMetadata(item));
  return !invalid;
}
export function findInvalidFieldsFromMetadata(contentMetadata, overrideProps, resolvers, rootMetadata = {}, skipHidden = true) {
  const preparedContent = prepareContentFromMetadata(contentMetadata, overrideProps, resolvers, rootMetadata);
  const fieldArray = findContentFromMetadata(preparedContent, item => item.type === 'field', skipHidden);
  const invalidFields = _filterInstanceProperty(fieldArray).call(fieldArray, item => !validateFieldUsingMetadata(item));
  return invalidFields;
}